module.exports = __webpack_public_path__ + "img/leonix-desarrollo-Web.94fd4aef.jpg";